<script setup lang="ts">
import { useUser } from '../utils/useUser'

import { DSAvatar, DSAvatarFallback } from '@ds'
import { ChevronUpIcon, ChevronDownIcon } from '@lucide/vue'

defineProps<{
  expanded?: boolean
  isMobile?: boolean
}>()

const { email, name, initials } = useUser()
</script>

<template>
  <button
    type="button"
    class="w-full flex items-center gap-2.5  rounded-ds-md cursor-pointer "
    :class="isMobile ? 'p-2 bg-white/10' : 'py-1 pr-2 pl-1 overflow-hidden'"
  >
    <DSAvatar
      size="xs"
      :class="isMobile ? 'bg-card' : 'bg-primary'"
    >
      <DSAvatarFallback :class="isMobile ? 'text-brand' : 'text-primary-foreground'">
        {{ initials }}
      </DSAvatarFallback>
    </DSAvatar>
    <span
      v-if="name || email"
      class="flex flex-col leading-tight items-start text-left"
      :class="isMobile ? 'flex-1 min-w-0' : 'overflow-hidden'"
    >
      <span
        v-if="name"
        class="w-full font-bold truncate"
        :class="isMobile ? 'text-[15px] text-primary-foreground' : 'max-w-30 text-sm text-foreground'"
      >{{ name }}</span>
      <span
        v-if="email"
        class="w-full text-xs font-medium truncate"
        :class="isMobile ? 'text-primary-foreground/70' : 'max-w-40 text-muted-foreground'"
      >{{ email }}</span>
    </span>
    <component
      :is="expanded ? ChevronUpIcon : ChevronDownIcon"
      class="shrink-0"
      :class="isMobile ? 'size-4.5 text-primary-foreground/60' : 'size-4 text-muted-foreground'"
      aria-hidden="true"
    />
  </button>
</template>
